import { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import { useProjectSelectionStore } from '../../stores/projectSelectionStore';

export function ProjectRedirect() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { selectProject } = useProjectSelectionStore();

  useEffect(() => {
    if (!id) return;
    // Load project to select it, then redirect to /home
    api.getProject(id).then(result => {
      if (result.success && result.data) {
        const p = result.data;
        selectProject({ id: p.id, title: p.title, status: p.status });
      }
      // Preserve #step=xxx hash
      navigate(`/home${location.hash}`, { replace: true });
    }).catch(() => {
      navigate('/home', { replace: true });
    });
  }, [id]);

  return (
    <div className="flex items-center justify-center h-48">
      <div className="text-gray-400 text-sm">読み込み中...</div>
    </div>
  );
}
